import { render, staticRenderFns } from "./FluxoAlocacoes.vue?vue&type=template&id=7658b90d&scoped=true"
import script from "./FluxoAlocacoes.vue?vue&type=script&lang=js"
export * from "./FluxoAlocacoes.vue?vue&type=script&lang=js"
import style0 from "./FluxoAlocacoes.vue?vue&type=style&index=0&id=7658b90d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7658b90d",
  null
  
)

export default component.exports